<template>
  <div>
    <!-- <van-image class="user-poster" width="100%" fit="contain" src="/user_background.jpg" /> -->
    <!-- <van-cell-group class="user-group">
      <van-cell icon="records" title="我的订单" is-link />
      <van-cell icon="like-o" title="收藏夹" is-link  to="cart" />
    </van-cell-group>-->
    <!-- <van-cell-group v-if="$store.getters.token" style="text-align: center" :border="false" >
        <van-cell  size="large" :title="" :border="false" />
        <van-cell size="large" :title="$store.getters.user.mobile" />
    </van-cell-group > -->
    <div class="mine-bg" style=" ">

      <div @click="toland" class="avatar">{{ $store.getters.user.name }}</div>
      <div v-if="$store.getters.token" @click="toland"
           style="display: flex;justify-content: space-between;flex: 1;">{{ $store.getters.user.mobile }}
        <van-icon v-if="$store.getters.shop.config.change_shop" name="arrow"/>
      </div>
      <div v-if="deposit_balance" style="flex:100%" v-html="deposit_balance"></div>
    </div>
    <van-cell-group v-if="$store.getters.token">
      <!-- <van-cell icon="manager-o" title="客户列表" is-link to="customer" /> -->
      <!--            <van-cell icon="orders-o" title="临时单列表" is-link to="/user/order?status=draft"/>-->
      <van-cell icon="orders-o" title="商品订单列表" is-link to="/user/order?status=draft"/>
      <van-cell icon="orders-o" title="面料订单列表" is-link to="/user/product_order?status=draft"/>
      <van-cell icon="location-o" title="地址管理" is-link to="/user/addresslist"/>
      <van-cell v-if="$store.getters.user.parentId == -1" icon="user-o" title="用户管理" is-link to="/usermanage"/>
      <van-cell v-if="$store.getters.user.parentId == -1" icon="gold-coin-o" @click="setPriceRatio()" title="设置倍率"/>
      <van-cell v-if="$store.getters.shop.phone&&isWeb" :url="'tel:'+$store.getters.shop.phone" icon="phone-o" title="联系我们" is-link/>

      <van-cell style="text-align: center;color: red" title="退出登录" @click="logout"/>


      <!--<van-cell v-if="$store.getters.use&&$store.getters.user.auth&&$store.getters.user.auth.AllowTogglePrice"
                center title="查看工厂价">
          <template #right-icon>
              <van-switch v-model="allow_toggle_price_checked" @input="onInput" size="24"/>
          </template>
      </van-cell>-->
    </van-cell-group>
    <div v-else>

      <van-button type="primary" block to="/login" class="login-button">去登录</van-button>
      <van-button v-if="false" type="primary" class="login-button" @click="toKeFu">客服</van-button>
    </div>
    <van-popup round closeable v-model="showSetPriceRatio">
      <div class="user_ratio">设置倍率</div>
      <van-form style="padding-top: 40px; width: 300px" @submit="onSubmitPriceRatio">
        <van-field
            v-model="priceDisplayTimes"
            name="倍率"
            label="倍率"
            placeholder="倍率"
            :rules="[{ required: true, message: '请填写倍率' }]"
        />

        <div style="margin: 16px">
          <van-button
              color="#f24749"
              round
              block
              type="info"
              native-type="submit">提交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <Footer :count="count"></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import {Dialog, Toast} from "vant";

export default {
  name: "User",

  components: {Footer},
  data() {
    return {
      checked: false,
      allow_toggle_price_checked: false,
      actions: [{name: '打开'}, {name: '关闭'}],
      show: false,
      showSetPriceRatio: false,
      priceDisplayTimes: 0,
      count: 0,
      deposit_balance: '',
      isWeb: true
    };
  },
  mounted() {
    this.count = localStorage.getItem('cartcount');
    this.allow_toggle_price_checked = localStorage.getItem('allow_toggle_price_checked') == 'true';
    /*this.$http.get("/clients/clientInfo").then((res) => {

        this.deposit_balance = '保证金：' + res.deposit_balance
    })
    wx.miniProgram.getEnv((res) => {

        if (res.miniprogram) {
            this.isWeb = true;
        }
    })*/
  },
  methods: {
    toKeFu() {
      console.log('to kefu page')
      wx && wx.miniProgram && wx.miniProgram.navigateTo({url: '/pages/kefu/kefu'})
    },
    setPriceRatio() {
      this.showSetPriceRatio = true
      let user = this.$store.getters.user
      this.priceDisplayTimes = user.priceDisplayTimes
    },
    onSubmitPriceRatio() {
      // 设置主账号倍率
      let user = this.$store.getters.user
      this.$http.put(process.env.VUE_APP_USER_baseURL + 'userPriceDisplayTimes', {
        "cloudUserId": user.id,
        "parentId": user.parentId,
        "priceDisplayTimes": this.priceDisplayTimes,
        "simple": true
      }).then(res => {
        this.showSetPriceRatio = false;
        user.priceDisplayTimes = this.priceDisplayTimes
        this.$store.commit("SET_USER", user)
        this.$store.commit("SET_PRICE_RATIO", this.priceDisplayTimes)
        if(res) Toast(res);
      });
    },
    onInput() {
      localStorage.setItem('allow_toggle_price_checked', this.allow_toggle_price_checked + '')
    },
    toland() {
      if (!this.$store.getters.shop.config.change_shop) {
        return
      }
      this.$router.replace("/land")


    },
    makephone() {

    },
    logout() {
      this.$dialog.confirm({
        title: '提示',
        message: '您确定要退出登录吗',
      })
          .then(() => {

            this.$store.dispatch("Logout");
            this.$store.dispatch("GetShop")
          })
    }
  }
};
</script>

<style>
.user-poster {
  width: 100%;
  max-height: 53vw;
  display: block;
}

.user-group {
  margin-bottom: 15px;
}

.user-links {
  padding: 15px 0;
  font-size: 12px;
  text-align: center;
  background-color: #fff;
}

.user-links .van-icon {
  display: block;
  font-size: 24px;
}

.login-button {
  margin-top: 1rem;
  transform: translate(10vw, 0);
  width: 80% !important;
}

.avatar {
  width: 60px;
  height: 60px;
  background: linear-gradient(267deg, #ff8440 2%, #ff6a50 100%);
  border-radius: 100%;
  line-height: 60px;
  text-align: center;
  font-size: 14px;
  color: rgb(255, 255, 255);
  margin-right: 20px;
  font-weight: 600;
  transition: all .3s ease;
  overflow: hidden;
}

.mine-bg {
  min-height: 140px;
  background: #1a67a5 url(//pic.c-ctrip.com/platform/h5/my/home/photo_myctrip@2x_6.22.jpg) no-repeat;
  display: flex;
  background-size: 100% 100%;
  align-items: center;
  padding-left: 20px;
  padding-right: 10px;
  color: #fff;
  flex-wrap: wrap;
}

.user_ratio {
  position: absolute;
  top: 15px;
  width: 100%;
  text-align: center;
  font-size: 14px;
}
</style>
